import {RestResource} from '../rest'

import { WORK_ORDER_SERVER } from '../server'

const jobPlanSpec = new RestResource({server: WORK_ORDER_SERVER, resource: 'jobplanspec'});

export default jobPlanSpec;